<template>
  <div class="d-flex justify-content-center align-items-center paypro">
    <div class="text-center">
      <div class="spinner loading"></div>
      <div class="error-text">Processing Payment...</div>
    </div>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import { PROJECT } from "@/helper/constant.js";

export default {
  name: "receiptPage",

  data() {
    return {
      project: PROJECT,
      token: null,
      dataKeys: {},
      ReserveID: ""
    };
  },
  created() {
    this.ReserveID = window.localStorage.getItem("ReserveID");
  },
  mounted() {
    this.token = this.$route.query.resultIndicator;
    this.getBookingDetails();
  },
  methods: {
    getBookingDetails: function() {
      let payload = {
        ReserveID: this.ReserveID || 16090,
        PaymentID: this.project == "ticketak" ? 4 : 2,
        SuccessIndicator: this.token
      };
      makeRequest("/ConfirmBooking", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data.Status) {
            this.$router.push({
              name: "confirmBooking",
              params: { bookingId: res.data.BookingID }
            });
          } else {
            window.location.pathname = "/failedPayment";
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          window.location.pathname = "/failedPayment";
          console.log("Error on vue front", error);
        });
    }
  }
};
</script>
<style>
.paypro {
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/receiptPage.vue